<template>
  <div class="basic_wrap">
  
	<div class="slot-machine">
		<van-swipe
		  :autoplay="0"
		  :loop="true"
		  :vertical="true"
		  :show-indicators="false"
		  ref="swipe1"
		  class="slot"
		>
		  <van-swipe-item v-for="(item, index) in items" :key="index">
			  <img width="100%" :src="item"/>
		  </van-swipe-item>
		</van-swipe>

		<van-swipe
		  :autoplay="0"
		  :vertical="true"
		  :loop="true"
		  :show-indicators="false"
		  ref="swipe2"
		  class="slot"
		>
		  <van-swipe-item v-for="(item, index) in items2" :key="index">
			  <img width="100%" :src="item"/>
		  </van-swipe-item>
		</van-swipe>

		<van-swipe
		  :autoplay="0"
		  :vertical="true"
		  :loop="true"
		  :show-indicators="false"
		  ref="swipe3"
		  class="slot"
		>
		  <van-swipe-item v-for="(item, index) in items3" :key="index">
			  <img width="100%" :src="item"/>
		  </van-swipe-item>
		</van-swipe>

		<van-button type="primary" @click="startSlotMachine">Start</van-button>
	</div>
    
  </div>
</template>
<script>
import Fetch from '../../utils/fetch';
import Vue from 'vue';
import {Tab, Tabs, Progress, Empty, Dialog, Field} from 'vant';
Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field);
import { Swipe, SwipeItem, Button, Toast } from 'vant';
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button);
Vue.use(Toast);

export default {
  name: "trading",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      tabs: [
        {name:0,title:this.$t('item.all')}
      ],
	  items: [
		  'https://imgs.aps388.top/static/img/slot1.jpg', 
		  'https://imgs.aps388.top/static/img/slot2.jpg', 
		  'https://imgs.aps388.top/static/img/slot3.jpg', 
		  'https://imgs.aps388.top/static/img/slot4.jpg', 
		  'https://imgs.aps388.top/static/img/slot5.jpg', 
		  'https://imgs.aps388.top/static/img/slot6.jpg', 
		  'https://imgs.aps388.top/static/img/slot2.jpg', 
		  'https://imgs.aps388.top/static/img/slot3.jpg', 
		  'https://imgs.aps388.top/static/img/slot4.jpg', 
		  'https://imgs.aps388.top/static/img/slot5.jpg', 
		  'https://imgs.aps388.top/static/img/slot6.jpg'], 
	  items2: ['https://imgs.aps388.top/static/img/slot1.jpg', 
		  'https://imgs.aps388.top/static/img/slot2.jpg', 
		  'https://imgs.aps388.top/static/img/slot3.jpg', 
		  'https://imgs.aps388.top/static/img/slot4.jpg', 
		  'https://imgs.aps388.top/static/img/slot5.jpg', 
		  'https://imgs.aps388.top/static/img/slot6.jpg', 
		  'https://imgs.aps388.top/static/img/slot2.jpg', 
		  'https://imgs.aps388.top/static/img/slot3.jpg', 
		  'https://imgs.aps388.top/static/img/slot4.jpg', 
		  'https://imgs.aps388.top/static/img/slot5.jpg', 
		  'https://imgs.aps388.top/static/img/slot6.jpg'],
	  items3: ['https://imgs.aps388.top/static/img/slot1.jpg', 
		  'https://imgs.aps388.top/static/img/slot2.jpg', 
		  'https://imgs.aps388.top/static/img/slot3.jpg', 
		  'https://imgs.aps388.top/static/img/slot4.jpg', 
		  'https://imgs.aps388.top/static/img/slot5.jpg', 
		  'https://imgs.aps388.top/static/img/slot6.jpg',
		  'https://imgs.aps388.top/static/img/slot1.jpg',
		  'https://imgs.aps388.top/static/img/slot2.jpg', 
		  'https://imgs.aps388.top/static/img/slot3.jpg', 
		  'https://imgs.aps388.top/static/img/slot4.jpg', 
		  'https://imgs.aps388.top/static/img/slot5.jpg', 
		  'https://imgs.aps388.top/static/img/slot6.jpg'],
	  isSpinning: false,
      active: 0,
	  acc:null,
	  vip:null,
      list: []
    }
  },
  created() {
    this.$parent.footer('trading');
  },
  mounted() {
    // this.accinfo();
    // this.start();
  },
  methods: {
	  startSlotMachine() {
		// if (this.isSpinning) return;
		// this.isSpinning = true;
  
		// const duration1 = Math.random() * 2000 + 2000;
		// const duration2 = Math.random() * 2000 + 2500;
		// const duration3 = Math.random() * 2000 + 3000;
  
		// this.spinReel(this.$refs.swipe1, 500,150);
		// this.spinReel(this.$refs.swipe2, 1000,70);
		// this.spinReel(this.$refs.swipe3, 1200,60);
		  this.spinReel(this.$refs.swipe3, 500,100);
		  this.spinReel(this.$refs.swipe2, 600,70);
		  this.spinReel(this.$refs.swipe1, 700,60);
  
		// setTimeout(() => {
		//   this.isSpinning = false;
		//   this.checkResult();
		// }, Math.max(duration1, duration2, duration3) + 500);
	  },
	  spinReel(swipe, duration,interval) {
		const itemCount = this.items.length;
		// const targetPosition = Math.floor(Math.random() * itemCount);
  
		let currentIndex = 0;
  
		const spin = setInterval(() => {
		  currentIndex = (currentIndex + 1);// % itemCount;
		  swipe.next();
		}, interval);
  
		setTimeout(() => {
		  clearInterval(spin);
		  // swipe.swipeTo(targetPosition, 300);
		}, duration);
	  },
	  checkResult() {
		const result1 = this.items[this.$refs.swipe1.activeIndex];
		const result2 = this.items[this.$refs.swipe2.activeIndex];
		const result3 = this.items[this.$refs.swipe3.activeIndex];
  
		if (result1 === result2 && result2 === result3) {
		  this.$toast.success('You Win!');
		} else {
		  this.$toast.fail('Try Again!');
		}
	},
	dateFormat(fmt, time) {
		var date = new Date(time*1000);
		var year = date.getFullYear();
		var month = ("0" + (date.getMonth() + 1)).slice(-2);
		var day = ("0" + date.getDate()).slice(-2);
		var hours = ("0" + date.getHours()).slice(-2);
		var minutes = ("0" + date.getMinutes()).slice(-2);
		var seconds = ("0" + date.getSeconds()).slice(-2);
		
		var formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		return formattedDate
	},
	receive(id){
	  Fetch('/user/trading_receive', {
        id: id
      }).then(r => {
		  this.$toast({
		      background: "#07c160",
		      message: this.$t('trading.receivesuc'),
		  });
		  this.list = r.data.list;
	  })
	},
	start() {
		Fetch('/user/item_trading').then(r => {
		  this.list = r.data.list;
		})
	},
	accinfo() {
		Fetch('/user/basicinfo').then((r) => {
			this.acc = r.data;
			this.vip = r.data.vip;
		});
	}
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-cell {
  padding: 15px 26px;
}
.btn{
    width: 62px;
    height: 24px;
    border-radius: 5px;
    font-size: 9px;
    color: #fff;
    margin-right: 8px;
    line-height: 24px;
}
.red_top_bg {

}

.basic_wrap {
  position: relative;
}

.item_wrap {
  width: 100%;
  padding: 44px 0 0 0;

  .tabs {
    position: fixed;
    z-index: 100;
    width: 100%;

    max-width: 750px;
  }
}

.item_margin {
  margin-top: 54px !important;
}
.work_content{
    padding-bottom: 26px;
    overflow: hidden;
	.main_work_title{
	    margin: 10px;
		padding: 20px;
		border-radius: 10px;
		background: #FFF;
	    text-align: center;
		position: relative;
		.h2{
			font-size: 14px;
			margin-top: 20px;
			em{
				color: #fc494d;
				font-size: 16px;
			}
		}
		span{
		    display: block;
		    margin: 0 auto 18px;
			img{
				width: 100%;
			}
		}
		.title{
		    text-align: center;
		    font-size: 20px;
		    color: #000;
		    font-weight: 700;
		}
	}
	.main_work{
	    overflow: hidden;
	    padding: 21px 17px;
	    box-sizing: border-box;
		border-radius: 10px;
		margin: 10px;
		background: #FFF;
		.title{
		    margin-bottom: 20px;
		    box-sizing: border-box;
		}
		.view-all{
		    color: #9999a5;
		    font-size: 14px;
			span{
			    width: 6px;
			    height: 11px;
			    margin-left: 7px;
				img{
					width: 6px;
					height: 11px;
				}
			}
		}
		.list{
		    margin-top: 10px;
			.lidiv{
			    height: 71px;
			    position: relative;
			    margin-bottom: 15px;
			    border-radius: 15px;
			    box-sizing: border-box;
				.icon {
					span:nth-child(1){
					    width: 50px;
					    height: 55px;
						img{
							width: 55px;
							height: 55px;
						}
					}
					.grow{
					    margin-left: 15px;
						.price{
						    font-size: 19px;
						    color: #48a093;
						    font-weight: 700;
						    display: flex;
						    align-items: flex-end;
							div{
							    font-size: 11px;
							    color: #2a2a2a;
							    margin-left: 5px;
							    margin-bottom: 2px;
							}
						}
						.des{
						    font-size: 10px;
						    color: #b4b6bd;
						    margin-top: 10px;
						    line-height: 15px;
						}
					}
				}
				.btn{
				    width: 65px;
				    height: 24px;
				    border-radius: 5px;
				    font-size: 9px;
				    color: #fff;
					margin-right: 8px;
					line-height: 24px;
				}
				.btn.disabled{
				    opacity: .65;
				}
			}
			.lidiv:nth-child(odd) {
			    background-color: #f8fdfb;
			}
			
		}
		
	}
}
.alcenter {
    align-items: center;
}
.flex {
    display: flex;
}
.font-bold {
    font-weight: 700;
}
.ft36 {
    font-size: 18px;
}
.c_191919 {
    color: #191919;
}
.flex-between {
    display: flex;
    justify-content: space-between!important;
}
.flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}
.main_title{
    position: relative;
    width: 100%;
    height: 203px;
    background-image: url(../images/trading/homeicon12.png);
    background-size: 100% 100%;
    padding: 62px 0 0 48px;
    box-sizing: border-box;
	.title{
	    color: #fff;
	    margin-bottom: 15px;
	}
	div:nth-child(3){
	    position: absolute;
	    top: 41px;
	    right: 12px;
	    width: 142px;
	    height: 126px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	
}
.ft28 {
	font-size: 14px;
}
.font-bold {
    font-weight: 700;
}
.ft48 {
    font-size: 24px;
}
.ml20 {
    margin-left: 10px;
}
.c-white {
    color: #fff;
}
.flex-wrap.flex-center{
    justify-content: space-between;
	margin-top: 20px;
	.left b {
        display: block;
        font-size: 16px;
        font-weight: 400;
    	text-align: left;
		margin-bottom: 10px;
    }
    .left em {
        display: block;
        margin-top: 5px;
        font-size: 12px;
        font-style: normal;
    	text-align: left;
        color: #ababab;
    }
}
.card-name {
	position: absolute;
	top: 0;
	left: 0;
	padding: 5px 15px;
	background-color: #fc494d;
	border-radius: 10px 0 5px 0;
	color: #fff;
	font-size: 14px;
}





.slot-machine {
  text-align: center;
}

.slot {
  width: 100px;
  height: 100px;
  margin: 10px;
  display: inline-block;
}

.van-swipe-item {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
</style>
